import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';
import { query } from '@dbk-legacy/muster/react';

import Text from '../../../../components/common/text';
import KeyValueListView from '../../../../components/common/key-value-list-view';
import AbbreviatedGroup from '../../../../components/common/abbreviated-group';
import NavigationArrow from '../../../../components/common/navigation-arrow';
import ChartHeader from '../chart-header';
import PriceHistoryChart from '../price-history-chart';

import styles from './asset-position-details.styles';
import TradeDetails from './trading-assets/trade-details';
import  getDetailFields  from './trading-assets/asset-position-details-field-mapping';

import TradePriceHistoryChart from '../asset-position-details/trading-assets/trade-asset-price-history-chart';
import { ASSETS, ENTITLEMENT, CTA } from '../asset-position-details/trading-assets/constants';
import TradeCTAButton from './trading-assets/trade-cta-button';

class AssetPositionDetails extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedInteractionValue: null,
    };

    this.handleInteractionChange = this.handleInteractionChange.bind(this);
    this.moveToTransaction = this.moveToTransaction.bind(this);
  }

  handleInteractionChange(value) {
    this.setState({
      selectedInteractionValue: value,
    });
  }
  moveToTransaction() {
     const {
      assetCategory,
      positionType,
      changePage,
      row = {},
    } = this.props;
    const {
      id,
    } = row;
    const linkValues = [assetCategory];
    if (positionType) {
      linkValues.push(positionType);
    }

    const positionIndex = row.index;
    linkValues.push(id);
    let link = "/portfolios/" + linkValues.join('/');
   
    this.props.moveToTransactionPage( assetCategory,positionIndex,link);
    

    //this.props.changePage({ pathname: link});
  }

  getAssetPositionDetails(props){

    const {
      chartHeaderComponent,
      landscapeComponent,
      row = {},
      detailsGroups = [],
      headerGroup,
      assetCategory,
      positionType,
      abbreviationRules,
      referenceCurrency,
      renderBottomSeparator = false,
      screen,
      messages,
    } = props;

    const { selectedInteractionValue } = this.state;

    const {
      id,
      positionCurrency,
      dayChange,
      dayChangePercentage,
      chartHeaderValue,
      chartHeaderValueUnit,
      priceHistory,
      proportion,
      isin,
      priceDate,
    } = row;

    const ChartHeaderComponent = chartHeaderComponent;
    const LandscapeComponent = landscapeComponent;
    const hasPriceHistory = typeof priceHistory !== 'undefined';
    const hasChartHeader = hasPriceHistory && ChartHeaderComponent !== null;
    const linkValues = [assetCategory];
    if (positionType) {
      linkValues.push(positionType);
    }
    linkValues.push(id);

    const abbreviatedGroupComponent = (
      <AbbreviatedGroup
        data={{
          ...row,
          marketValueUnit: referenceCurrency,
          unrealisedGLUnit: referenceCurrency,
        }}
        dataDefinitions={headerGroup}
        abbreviationRules={abbreviationRules}
        renderTopSeparator={hasChartHeader || hasPriceHistory}
        renderBottomSeparator={renderBottomSeparator}
        messages={messages}
      />
    );

    return(
      <div testID="expandable-item">
        <div className="row">
          { hasChartHeader &&
            <ChartHeaderComponent
              dayChange={dayChange}
              dayChangePercentage={dayChangePercentage}
              value={chartHeaderValue}
              valueUnit={chartHeaderValueUnit}
              priceDateValue={priceDate}
              messages={messages}
            />
          }
          {abbreviatedGroupComponent}
        </div>
        <div className="row">
          <KeyValueListView
            detailsGroups={detailsGroups}
            row={row}
            renderFirstSeparator={hasChartHeader || hasPriceHistory}
            screen={screen}
            messages={messages}
          />
        </div>
        {hasPriceHistory &&
          <div className="row" testID="graph">
            <PriceHistoryChart
              currency={positionCurrency}
              data={priceHistory}
              // height={250}
              // width={600}
              selectedInteractionValue={selectedInteractionValue}
              onInteractionChange={this.handleInteractionChange}
              screen={screen}
              messages={messages}
            />
          </div>
        }
        <div className="row">
          <div style={{'display': 'inline-block', 'cursor': 'pointer'}} onClick={this.moveToTransaction} id="link_seetransaction_assetPositionDetails_test">
            <Text>{messages['app.portfolio.assetDetails.seeTrans']}</Text>
            <span className="arrowClass"><NavigationArrow/></span>
          </div>
        </div>
      </div>
    )
  }

  getAssetPositionDetailsForTrading(props){

    const { selectedPortfolio, row, messages, isVascoActivated, assetCategory } =  props;

    const { enabled, tradable, restricted } = row;

    // user portfolio entitlement(P4) check
    const showHideTradeableButton = selectedPortfolio.isTradingAvailable;
    const enableDisableTradeableButton = (restricted === ENTITLEMENT.NO) &&
                                        (enabled === ENTITLEMENT.YES) &&
                                      (tradable === ENTITLEMENT.YES);
                            // these flags are used for entitlement check

    return(
      <div className="security_detail_root trade-page security-list-item">
        <div className="security_detail">
          <div className="columns medium-6 small-12 chart_section" testID={"chart_position_entry_test"} accessibilityLabel={"chart_position_entry_test"}>
            <TradePriceHistoryChart
                  row={row}
                  data={row.priceHistory}
                  messages={messages}
                  currencyCode={row.positionCurrency}/>
          </div>

          <div className="columns medium-6 small-12" id="position-entry-asset-container" testID={"details_position_entry_test"} accessibilityLabel={"details_position_entry_test"}>
            <TradeDetails data={getDetailFields(assetCategory, row, messages)}
                      messages={messages}/>
              { (restricted === ENTITLEMENT.YES) &&
                        <div className="position-entry-error">
                          <span>{messages["app.trade.label.restrictedTrade"]}</span>
                        </div>
               }
          </div>
        </div>
        <div className="position-entry-asset-cta">
          { row.id && <TradeCTAButton handleClick={this.moveToTransaction} className="positon-cta-buttons"
              message={messages["app.trade.label.cta.seeTransactions"]}
              tertiary />
          }
          {
            showHideTradeableButton && isVascoActivated &&
            <TradeCTAButton handleClick={() => this.props.handleCtaClick(CTA.SELL, row)} className="positon-cta-buttons"
            message={messages["app.trade.label.cta.sell"]} disabled={!enableDisableTradeableButton}/>
          }
          {
            showHideTradeableButton && isVascoActivated &&
            <TradeCTAButton handleClick={() => this.props.handleCtaClick(CTA.BUY, row)} className="positon-cta-buttons"
            disabled={!enableDisableTradeableButton} message={messages["app.trade.label.cta.buy"]}/> 
          }
        </div>
     </div>
    )
  }
  render() {
    
    const tradingAssets = ['equities'];
    const isTradeAsset = tradingAssets.some((el) => (this.props.assetCategory && this.props.assetCategory.includes(el)));

    return (
      <View>
      { isTradeAsset ? this.getAssetPositionDetailsForTrading(this.props) : this.getAssetPositionDetails(this.props) }
      </View>
    );
      
    
  }
}

AssetPositionDetails.defaultProps = {
  chartHeaderComponent: ChartHeader,
  abbreviationRules: {},
  headerGroup: [],
  screen: {
    isSmall: false,
  },
};

AssetPositionDetails.propTypes = {
  assetCategory: PropTypes.string.isRequired,
  positionType: PropTypes.string,
  referenceCurrency: PropTypes.string,
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    isin: PropTypes.string,
    positionCurrency: PropTypes.string,
    dayChange: PropTypes.number,
    dayChangePercentage: PropTypes.number,
    chartHeaderValue: PropTypes.number,
    chartHeaderValueUnit: PropTypes.string,
    priceHistory: PropTypes.array,
    quantity: PropTypes.number,
    marketValue: PropTypes.number,
    unrealisedGL: PropTypes.number,
  }),
  detailsGroups: KeyValueListView.propTypes.detailsGroups,
  headerGroup: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string,
  })),
  chartHeaderComponent: PropTypes.func,
  selectedChartInteractionValue: PropTypes.number,
  onChartInteractionChange: PropTypes.func,
  landscapeComponent: PropTypes.func,
  abbreviationRules: PropTypes.object,
  screen: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    isSmall: PropTypes.bool,
  }),
};

export default AssetPositionDetails;
